import { Link } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { Button } from "@/components/ui/button";
import { useCollections } from "@/hooks/useData";
import { imgUrl } from "@/lib/api";

export default function CollectionsPage() {
  const { data: collections = [] } = useCollections();
  return (
    <div data-testid="collections-page">
      <PageHeader eyebrow="Curated Collections" title="Four aesthetics," accent="one standard." description="Each collection is a distinct point of view — explore the one that matches your space and source it with us." />
      <div className="space-y-20 sm:space-y-32 py-20 sm:py-28">
        {collections.map((c, i) => (
          <div key={c.id} className="max-w-7xl mx-auto px-5 sm:px-8">
            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}>
              <Reveal className="img-frame group aspect-[4/3]">
                <img src={imgUrl(c.image_url)} alt={c.name} className="w-full h-full object-cover" />
              </Reveal>
              <div>
                <span className="font-display text-6xl text-[#ECEAE4]">0{i + 1}</span>
                <h2 className="font-display text-4xl sm:text-5xl font-medium text-[#2C2A29] mt-2">{c.name}</h2>
                <p className="text-[#9E8773] font-light italic text-xl mt-2">{c.tagline}</p>
                <p className="text-[#5E5A54] font-light leading-relaxed mt-5 text-lg">{c.description}</p>
                <Button asChild className="rounded-none bg-[#2C2A29] hover:bg-[#4A4641] text-[#FFFFFF] h-12 px-8 label-eyebrow text-[10px] mt-8">
                  <Link to={`/store?collection=${encodeURIComponent(c.name)}`} data-testid={`explore-collection-${i}`}>Explore {c.name}</Link>
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
